/**
 * Introduced in LIVE-25190 Auto add guests to main event
 * Used by getShouldAddGuestToMainEvent selector to determine if guests should be automatically added to the main event for new weddings created after this date
 * and in plus one flow to determine if we should automatically add plus ones to the main event
 */
export const ADD_GUEST_TO_MAIN_EVENT_BY_DEFAULT_ACTIVATE_DATE = new Date(
  2025,
  10,
  17,
  22,
).getTime();
